import React, {useEffect, useState} from 'react';

const PackageCard = ({ packageData, onLimitClick, onRegionClick }) => {
  console.log("packageData: ", packageData);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Initial check
    checkMobile();

    // Add resize listener
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const regionCount = packageData.regions && packageData.regions.length > 0
    ? packageData.regions.length
    : 'все';
  const countLeadsMonth = packageData.leads_current_month && packageData.leads_current_month.length > 0
    ? packageData.leads_current_month.length
    : '0';
  return (
      <div className="package-card">

        <div className="package-middle-content">
          <div className="flow-content-block">
            <span className="flow-content-number-middle">{countLeadsMonth || '0'}</span>
            <span className="flow-content-label-middle">за {new Date().toLocaleDateString('ru-RU', { month: 'long' })}</span>
          </div>
        </div>

        <div className="package-card-content">
          <div className="package-card-title">
            <span style={{}}>Пакет</span>
            <span className="package-card-title-name">"{packageData.name}"</span>
          </div>

          <div className="package-card-info">
            <div className="package-card-info-left">
              <span>Лимит в день:</span>
              <span className="package-card-info-count"> {packageData.limit}</span>
            </div>
            <div className="package-card-info-edit" onClick={onLimitClick}>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6205 5.62325L12.1613 5.0825C12.5914 4.65233 12.8331 4.0689 12.8331 3.46054C12.8331 2.85219 12.5914 2.26876 12.1613 1.83859C11.7311 1.40842 11.1477 1.16675 10.5393 1.16675C9.93095 1.16675 9.34752 1.40842 8.91735 1.83859L8.3766 2.37934L3.40543 7.34933C3.06885 7.6865 2.90026 7.85509 2.7556 8.04059C2.58491 8.25961 2.43842 8.49646 2.31868 8.747C2.21776 8.95933 2.14251 9.18567 1.99201 9.63717L1.35385 11.5511M11.6205 5.62325C11.6205 5.62325 10.4719 5.55559 9.4581 4.54175C8.44426 3.5285 8.37718 2.37934 8.37718 2.37934M11.6205 5.62325L6.64993 10.5933C6.31335 10.9298 6.14476 11.0984 5.95926 11.2431C5.74024 11.4138 5.50339 11.5603 5.25285 11.68C5.04051 11.7809 4.81476 11.8562 4.36268 12.0067L2.44876 12.6448M2.44876 12.6448L1.98093 12.8012C1.87188 12.8377 1.75479 12.8432 1.64282 12.8168C1.53086 12.7905 1.42845 12.7335 1.34712 12.6521C1.26579 12.5708 1.20876 12.4684 1.18243 12.3564C1.1561 12.2445 1.16153 12.1274 1.1981 12.0183L1.35443 11.5505L2.44876 12.6448Z"
                    stroke="#777777" stroke-width="0.875"/>
              </svg>
            </div>
          </div>

          <div className="package-card-info">
            <div className="package-card-info-left">
              <span>Кол-во регионов:</span>
              <span className="package-card-info-count"> {regionCount}</span>
            </div>
            {packageData.paks_id !== 1 && (
              <div className="package-card-info-edit" onClick={onRegionClick}>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M11.6205 5.62325L12.1613 5.0825C12.5914 4.65233 12.8331 4.0689 12.8331 3.46054C12.8331 2.85219 12.5914 2.26876 12.1613 1.83859C11.7311 1.40842 11.1477 1.16675 10.5393 1.16675C9.93095 1.16675 9.34752 1.40842 8.91735 1.83859L8.3766 2.37934L3.40543 7.34933C3.06885 7.6865 2.90026 7.85509 2.7556 8.04059C2.58491 8.25961 2.43842 8.49646 2.31868 8.747C2.21776 8.95933 2.14251 9.18567 1.99201 9.63717L1.35385 11.5511M11.6205 5.62325C11.6205 5.62325 10.4719 5.55559 9.4581 4.54175C8.44426 3.5285 8.37718 2.37934 8.37718 2.37934M11.6205 5.62325L6.64993 10.5933C6.31335 10.9298 6.14476 11.0984 5.95926 11.2431C5.74024 11.4138 5.50339 11.5603 5.25285 11.68C5.04051 11.7809 4.81476 11.8562 4.36268 12.0067L2.44876 12.6448M2.44876 12.6448L1.98093 12.8012C1.87188 12.8377 1.75479 12.8432 1.64282 12.8168C1.53086 12.7905 1.42845 12.7335 1.34712 12.6521C1.26579 12.5708 1.20876 12.4684 1.18243 12.3564C1.1561 12.2445 1.16153 12.1274 1.1981 12.0183L1.35443 11.5505L2.44876 12.6448Z"
                      stroke="#777777" stroke-width="0.875"/>
                </svg>
              </div>
            )}
          </div>
        </div>
      </div>
  );
};

export default PackageCard;